"use client"

import { isGlsOption } from "@/lib/util/gls-shipping"
import { HttpTypes } from "@medusajs/types"
import { Text, clx } from "@medusajs/ui"

type GlsFragileItemsNoticeProps = {
  shippingOptions: HttpTypes.StoreCartShippingOption[]
  selectedMethodId?: string
  className?: string
}

const GlsFragileItemsNotice = ({
  shippingOptions,
  selectedMethodId,
  className,
}: GlsFragileItemsNoticeProps) => {
  if (!shippingOptions.some(isGlsOption)) {
    return null
  }

  const selectedOption = shippingOptions.find(
    (option) => option.id === selectedMethodId
  )
  const isGlsSelected = isGlsOption(selectedOption)

  return (
    <div
      role="note"
      className={clx(
        "relative overflow-hidden rounded-xl border transition-colors duration-200",
        isGlsSelected
          ? "border-amber-300/80 bg-gradient-to-br from-amber-50 via-orange-50/80 to-rose-50/60 shadow-sm"
          : "border-amber-200/70 bg-gradient-to-br from-amber-50/70 via-white to-orange-50/40",
        className
      )}
    >
      <div
        className={clx(
          "absolute inset-y-0 left-0 w-1 rounded-l-xl",
          isGlsSelected ? "bg-amber-500" : "bg-amber-300"
        )}
        aria-hidden
      />

      <div className="flex gap-3 p-4 pl-5">
        <div
          className={clx(
            "flex h-10 w-10 shrink-0 items-center justify-center rounded-full",
            isGlsSelected
              ? "bg-amber-100 text-amber-700 ring-1 ring-amber-200"
              : "bg-amber-50 text-amber-600 ring-1 ring-amber-100"
          )}
          aria-hidden
        >
          <svg
            viewBox="0 0 24 24"
            fill="none"
            className="h-5 w-5"
            stroke="currentColor"
            strokeWidth="1.75"
          >
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              d="M12 9v4m0 4h.01M10.29 3.86 1.82 18a2 2 0 0 0 1.71 3h16.94a2 2 0 0 0 1.71-3L13.71 3.86a2 2 0 0 0-3.42 0Z"
            />
          </svg>
        </div>

        <div className="min-w-0 flex-1 space-y-1.5">
          <Text
            className={clx(
              "text-sm font-semibold leading-snug",
              isGlsSelected ? "text-amber-950" : "text-amber-900"
            )}
          >
            Lomljivi izdelki in GLS dostava
          </Text>
          <Text className="text-sm leading-relaxed text-amber-900/85">
            Če vaše naročilo vsebuje{" "}
            <span className="font-medium">lomljive izdelke</span> — na primer{" "}
            <span className="font-medium">steklo, porcelan ali keramiko</span>{" "}
            — GLS dostave{" "}
            <span className="font-medium">ne priporočamo</span>. Izberite drug
            način dostave ali nas kontaktirajte za pomoč.
          </Text>
        </div>
      </div>
    </div>
  )
}

export default GlsFragileItemsNotice
